export default {
    lang: {
        name: 'Want parts'
    }
}